import { render } from "./vdentcloudlogo.vue?vue&type=template&id=4b15cd96"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__